import React from 'react'

import PaperPanel from '../../components/PaperPanel'
import TextParagraphs from '../../components/TextParagraphs'

function LandingMainText({gameState, togglePopUp}) {
    let titleText = ''
    let bodyText = []
        
    if (gameState === 'continueGame') {
        titleText = 'The Story So Far...'
        bodyText = [
            "Professor Foxworth is missing! His office was trashed and vital notes for the professor's latest invention are stolen. It is safe to assume that whoever has taken the Professor does not intend to use his research for good.",

            "Luckily the Professor made plans for this and has left P.I. Larry Maxwell a tricky trail of clues to secure the main parts of his research. With a bit of luck, following the Professor's trail will help us find the Professor himself before it is too late.",

            'Remember every detective needs a little help sometimes. Even Larry. If you need a nudge in the right direction, you can request a hint using the NYPD Helpdesk at each location.',

            'Good luck!'
        ]  
    } else if (gameState === 'machineGame') {
        titleText = 'The Story So Far...'
        bodyText = [
            "Professor Foxworth was kidnapped but he made plans to keep his research safe.",
            
            "P.I. Larry Maxwell, with your help, followed the Professor's trail of clues to secure the research and discovered that the Professor was being held at a warehouse by the docks.",

            "After breaking into the warehouse, Larry discovered it was the secret location of the Professor's ground breaking invention 'The Machine'. The Professor's captors were trying to make it work but idavertently caused 'The Machine' to malfunction putting the whole of New York in danger.",

            "After knocking the Professor unconcious the gangsters scarpered, leaving Larry to make things right.",

            'Good luck!'
        ]  
    }else if (gameState === 'winGame') {
        titleText = 'You Solved The Case!'
        bodyText = [
            'Professor Foxworth and his research are safe thanks to your efforts. Well done on completing The Case Of The Kidnapped Professor.',

            'As one case closes another opens. P.I. Larry Maxwell needs your help on more investigations. There is a diamond that has disappeared from the City Museum and the trial of Vince Baxter is due to start any day, open and shut case, provided the evidence makes it to the court.',

            'You can find out about these, plus all the other incredible online and real world escape games Paradox Parlours has to offer by visiting the website.',

            'See you at the next mystery!'
        ]
    } else {
        titleText = 'Instructions - Read Me First'
        bodyText = [
            'Private Investigator Larry Maxwell needs your help on the latest case and there is no time to lose!',

            "If you don't already have a copy, the download button on this page will provide you with the Professor's Journal. You should print these pages and keep them safe as different parts will be needed throughout the game.",

            'Remember every detective needs a little help sometimes. Even Larry. If you need a nudge in the right direction, you can request a hint using the NYPD Helpdesk at each location.',

            'Good luck!'
        ]       
    }
        
    return (
        <PaperPanel extraClasses={`landing_infoPanel`}>
            <h4 className="welcome">
                {gameState === 'winGame' ? 'Congratulatons' : gameState === 'newGame' ? 'Welcome' : 'Welcome Back'} Detectives
            </h4>
            <h3 className={`${gameState}_title`}>{titleText}</h3>
            <TextParagraphs extraClasses={`${gameState}_text`} text={bodyText} />
        </PaperPanel>
    )
}

export default LandingMainText